// ============================================
// IMPORT ALL PAGE COMPONENTS
// ============================================

// Auth Pages
import Login from "../pages/auth/Login";
import ForgotPassword from "../pages/auth/ForgotPassword";

// Main Pages
import Dashboard from "../pages/dashboard/Dashboard";
import LiveSession from "../pages/live_session/LiveSession";
import OutletLiveSession from "../pages/live_session/OutletLiveSession";
import MobileLiveSession from "../pages/live_session/MobileLiveSession";
import Profile from "../pages/profile/Profile";

// Admin Pages
import AdminManage from "../pages/admin_manage/AdminManage";

// Game Management
import YantraManage from "../pages/yantra_manage/YantraManage";
import GameSession from "../pages/game_session/GameSession";
import SessionWinningDetails from "../pages/game_session/SessionWinningDetails";
import Settings from "../pages/setting/Settings";

// Transaction & History
import TransactionHistory from "../pages/history/TransactionHistory";
import WithdrawalMangement from "../pages/withdrawal/WithdrawalMangement";
import PlaceBetManagement from "../pages/pleace_bet/PlaceBetManagement";
import WalletManage from "../pages/wallet_manage/WalletManage";
import WalletTransfer from "../pages/wallet/WalletTransfer";

// Jackpot Management
import Jackpot from "../pages/jackpot/Jackpot";
import JackpotX from "../pages/jackpotx/JackpotX";
import ManualWinner from "../pages/manual_winner/ManualWinner";

// Report Management
import ReportManage from "../pages/report/ReportManage";
// Draw Management
import AllDraw from "../pages/draw/AllDraw";
import ViewBetByQr from "../pages/view_bet/ViewBetByQr";
// User Management
import MobileUserManage from "../pages/mobile_user_manage/MobileUserManage";
import OutLetManage from "../pages/outlate_manage/OutLetManage";
import HisabKitabManage from "../pages/hisab_kitab/HisabKitabManage";

// ============================================
// ROLE-BASED ACCESS CONTROL
// ============================================
// Roles: 1 = Super Admin, 2 = Admin, 3 = User/Player

// ============================================
// AUTH ROUTES (No authentication required)
// ============================================
const authRoutes = [
  {
    path: "/",
    exact: true,
    component: Login,
    layout: "none",
    name: "Home",
  },
  {
    path: "/login",
    component: Login,
    layout: "none",
    name: "Login",
  },
  {
    path: "/forgot-password",
    component: ForgotPassword,
    layout: "none",
    name: "Forgot Password",
  },
];

// ============================================
// PROTECTED ROUTES (Authentication required)
// ============================================
const protectedRoutes = [
  // Dashboard & Profile
  {
    path: "/dashboard",
    component: Dashboard,
    layout: "main",
    name: "Dashboard",
    requiresAuth: true,
    roles: [1, 2, 3, 4],
  },
  {
    path: "/profile",
    component: Profile,
    layout: "main",
    name: "My Profile",
    requiresAuth: true,
    roles: [1, 2, 3, 4],
  },

  // Live Gaming
  {
    path: "/live-session",
    component: LiveSession,
    layout: "main",
    name: "Live Session",
    requiresAuth: true,
    roles: [1],
  },
  {
    path: "/outlet-live-session",
    component: OutletLiveSession,
    layout: "main",
    name: "Live Session",
    requiresAuth: true,
    roles: [3],
  },
  {
    path: "/mobile-live-session",
    component: MobileLiveSession,
    layout: "main",
    name: "Live Session",
    requiresAuth: true,
    roles: [4],
  },

  // Admin Management (Super Admin & Admin only)
  {
    path: "/admin-users",
    component: AdminManage,
    layout: "main",
    name: "Admin Users",
    requiresAuth: true,
    roles: [1, 2],
  },

  //YantraManage

  {
    path: "/yantra-manage",
    component: YantraManage,
    layout: "main",
    name: "Yantra Manage",
    requiresAuth: true,
    roles: [1],
  },
  {
    path: "/report-manage",
    component: ReportManage,
    layout: "main",
    name: "Report",
    requiresAuth: true,
    roles: [1, 2, 3],
  },
  {
    path: "/settings",
    component: Settings,
    layout: "main",
    name: "Settings",
    requiresAuth: true,
    roles: [1],
  },
  // Game Sessions Management
  {
    path: "/game-sessions",
    component: GameSession,
    layout: "main",
    name: "Yantra Sessions",
    requiresAuth: true,
    roles: [1, 2],
  },
  {
    path: "/session-winning-detail",
    component: SessionWinningDetails,
    layout: "main",
    name: "Session Winning Detail",
    requiresAuth: true,
    roles: [1, 2],
  },

  // Outlet Management
  {
    path: "/outlets",
    component: OutLetManage,
    layout: "main",
    name: "Outlets",
    requiresAuth: true,
    roles: [1, 2],
  },

  // Mobile User Management
  {
    path: "/mobile-users",
    component: MobileUserManage,
    layout: "main",
    name: "Mobile Users",
    requiresAuth: true,
    roles: [1, 2, 3],
  },

  // Jackpot Management
  {
    path: "/jackpot",
    component: JackpotX,
    layout: "main",
    name: "Jackpot",
    requiresAuth: true,
    roles: [1],
  },
  {
    path: "/multi-winner",
    component: Jackpot,
    layout: "main",
    name: "Multi Winner",
    requiresAuth: true,
    roles: [1],
  },
  {
    path: "/manual-winner",
    component: ManualWinner,
    layout: "main",
    name: "Manual Winners",
    requiresAuth: true,
    roles: [1],
  },

  // Transaction History
  {
    path: "/transaction-history",
    component: TransactionHistory,
    layout: "main",
    name: "Transaction History",
    requiresAuth: true,
    roles: [1, 2, 3, 4],
  },
  {
    path: "/wallet-manage",
    component: WalletManage,
    layout: "main",
    name: "Wallet Manage",
    requiresAuth: true,
    roles: [1, 2],
  },
  // {
  //   path: "/withdrawal-management",
  //   component: WithdrawalMangement,
  //   layout: "main",
  //   name: "Withdrawal Management",
  //   requiresAuth: true,
  //   roles: [1, 2, 3, 4],
  // },
  {
    path: "/place-bet-management",
    component: PlaceBetManagement,
    layout: "main",
    name: "Place Bet Management",
    requiresAuth: true,
    roles: [3, 4],
  },
  {
    path: "/all-draw",
    component: AllDraw,
    layout: "main",
    name: "All Draw",
    requiresAuth: true,
    roles: [1, 2, 3, 4],
  },
  {
    path: "/balance-transfer",
    component: WalletTransfer,
    layout: "main",
    name: "Balance Transfer",
    requiresAuth: true,
    roles: [1, 2, 3],
  },
  {
    path: "/hisab-kitab",
    component: HisabKitabManage,
    layout: "main",
    name: "Hisab Kitab",
    requiresAuth: true,
    roles: [1, 2, 3],
  },
];

// ============================================
// PUBLIC ROUTES (Accessible to everyone)
// ============================================
const publicRoutes = [
  {
    path: "/view-bet/:uid",
    component: ViewBetByQr,
    layout: "main",
    name: "View Bet",
  },
  {
    path: "/about",
    component: () => (
      <div style={{ padding: "40px 20px" }}>
        <h1>About</h1>
        <p>Coming soon...</p>
      </div>
    ),
    layout: "main",
    name: "About",
  },
  {
    path: "/contact",
    component: () => (
      <div style={{ padding: "40px 20px" }}>
        <h1>Contact</h1>
        <p>Coming soon...</p>
      </div>
    ),
    layout: "main",
    name: "Contact",
  },
];

// ============================================
// COMBINE ALL ROUTES
// ============================================
export const allRoutes = [...authRoutes, ...protectedRoutes, ...publicRoutes];

// ============================================
// ROUTE CONFIGURATION BY ACCESS LEVEL
// ============================================
export const routes = {
  auth: authRoutes,
  protected: protectedRoutes,
  public: publicRoutes,
  all: allRoutes,
};

// ============================================
// ROUTE HELPER FUNCTIONS
// ============================================

/**
 * Get a specific route configuration by path
 * @param {string} path - Route path
 * @returns {object|undefined} - Route configuration or undefined
 */
export const getRoute = (path) => {
  return allRoutes.find((route) => route.path === path);
};

/**
 * Check if a route requires authentication
 * @param {string} path - Route path
 * @returns {boolean} - True if route requires auth
 */
export const isProtectedRoute = (path) => {
  const route = getRoute(path);
  return route && route.requiresAuth;
};

/**
 * Get layout type for a route
 * @param {string} path - Route path
 * @returns {string} - Layout type ('main', 'none', etc.)
 */
export const getLayoutType = (path) => {
  const route = getRoute(path);
  return route ? route.layout : "main";
};

/**
 * Check if user has access to a specific route
 * @param {string} path - Route path
 * @param {number} userRole - User's role ID
 * @returns {boolean} - True if user has access
 */
export const hasRouteAccess = (path, userRole) => {
  const route = getRoute(path);
  if (!route) return false;
  if (!route.roles) return true; // No role restriction
  return route.roles.includes(userRole);
};

/**
 * Get accessible routes for a user role
 * @param {number} userRole - User's role ID
 * @returns {array} - Array of accessible routes
 */
export const getAccessibleRoutes = (userRole) => {
  return protectedRoutes.filter((route) => {
    if (!route.roles) return true;
    return route.roles.includes(userRole);
  });
};

// ============================================
// ROLE REFERENCE
// ============================================
// 1 = Super Admin (Full access to all admin routes)
// 2 = Admin (Access to most admin routes)
// 3 = Regular User/Player (Access to user-level routes only)

export default allRoutes;
